import React, { useEffect, useState } from 'react';
import { Scale, Heart, Briefcase, IndianRupee, Shield, AlertCircle, CheckCircle, ChevronDown } from 'lucide-react';
import Layout from '../../../components/web/Layout';

const Rules = () => {
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    const initialState = {};
    rulesData.forEach((_, index) => {
      initialState[index] = false;
    });
    setExpandedSections(initialState);
  }, []);

  const toggleSection = (index) => {
    setExpandedSections(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const rulesData = [
        {
      title: "MEDICAL BENEFIT",
      icon: Heart,
      color: "from-rose-500 to-pink-600",
      bgColor: "bg-rose-50",
      rules: [
        "Proper documentation for only current year required while submitting the medical application, medical applications should be submitted within one month of the discharge from the hospital.",
        "Relation with the family members should be established with valid documentary proof such as Aadhar Card, Ration card etc.",
        "Unmarried members – Mother and Father shall be considered as family member for the family medical benefit\nMarried members: Spouse and children below age of 21 years shall be considered as family member for the family medical benefit\nHowever, in case the member has special child then there shall be no age bar for the respective special child.",
        "No hospitalization required for cataract surgery",
        "Chronicle diseases such as – Cancer, paralysis, Kidney Failure, Blindness, Permanent Physical Disabilities caused due to which the member shall not be able to work, in such cases the subscription fees of such members shall be ceased and that the medical benefit shall be given to the member only and not his family.",
        "Current year subscription should be cleared before claiming any medical aid from the association. Medical applications from the members whose subscription is pending for two or more years shall not be accepted. Medical applications of such members shall be accepted only after one year of the clearance of such pending subscription fees.",
        "For New Member: Medical benefit can be applied for only after completion of three years of membership in the association without any default in the subscription fees.",
        "Medical application received after the death of the respective person whose medical benefit is claimed for shall not be accepted. (Suggestion : it should be accepted if the medical aid is applied for within a month of the death of the respective person)",
        "Members who are involved into anti-association activities or are debarred from the association shall not be allowed to apply for the medical aid or disputes."
      ]
    },
    {
      title: "DISPUTE MATTERS",
      icon: Scale,
      color: "from-blue-500 to-cyan-600",
      bgColor: "bg-blue-50",
      rules: [
        "DISPUTE cases of members will be fought in the association only for the work as per their designation.",
        "Association is strictly against any contract system. Any disputes received pertaining to such contracts shall not be accepted.",
        "Dispute cases shall be accepted only for member's fees. No dispute shall be accepted for any property, transport or labour fees. Disputes of members pertaining to their work in setting and shooting shall only be accepted.",
        "Members who have received the membership number are only allowed to submit dispute matters in the association. Any member whose subscription installments are pending shall not be allowed to submit dispute matters.",
        "Any subscription pending should be first cleared before submitting any dispute matter.",
        "Complaints of members with inappropriate details such as the email Id's, Phone Numbers, production house address and other relevant details with proof of outstanding dues shall not be accepted.",
        "Member-Member working is compulsory. Member - Nonmember complaints shall not be accepted.",
        "We shall not handle any disputes in which either parties have approached the court of law or police station for resolution of their disputes. Matter which are sub-judice shall not be accepted by the association",
        "Any disputes which does not fit in the above criteria can be discussed in the committee meeting and considered accordingly."
      ]
    },

    {
      title: "RETIREMENT BENEFIT",
      icon: Briefcase,
      color: "from-amber-500 to-orange-600",
      bgColor: "bg-amber-50",
      rules: [
        "Any member who has attained the age of 65 years shall be eligible for the retirement benefit.",
        "No retirement application below 65 years of age shall be accepted",
        "Subscriptions of such members should be cleared till date. Any pending subscription shall not be eligible for retirement benefit.",
        "While submission of the retirement benefit application the nomination details should also be furnished by the respective member."
      ]
    },
    
    {
      title: "PENSION",
      icon: IndianRupee,
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-emerald-50",
      rules: [
        "Pension will be paid only after one year of the receipt of the retirement benefit.",
        "Pension shall be ceased after the death of the member.",
        "Pension shall not be approved until the retirement application is approved and paid off."
      ]
    },
    {
      title: "DEATH COMPENSATION",
      icon: Shield,
      color: "from-purple-500 to-indigo-600",
      bgColor: "bg-purple-50",
      rules: [
        "Death Certificate is mandatory with the application of Death compensation",
        "Nomination should be registered by the member with documentary proof for relationship of the nominee with the member.",
        "Subscription should be cleared till date."
      ]
    },
  ];

  return (
    <Layout>
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="relative bg-gradient-to-r from-gray-900 via-gray-800 to-black text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-72 h-72 bg-blue-500 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-500 rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-500 rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
        </div>
        
        <div className="relative container mx-auto px-4 py-20 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full filter blur-xl opacity-50 animate-pulse"></div>
              <div className="relative bg-white/10 backdrop-blur-lg rounded-full p-6 border-2 border-white/20">
                <Scale className="w-16 h-16 text-white" />
              </div>
            </div>
          </div>
          <h1 className="text-5xl md:text-7xl font-black mb-4 tracking-tight">
            RULES & REGULATIONS
          </h1>
          <div className="w-32 h-1.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 mx-auto rounded-full mb-6"></div>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto font-light">
            Guidelines and policies for ACTADCD members
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 max-w-5xl">
        {rulesData.map((section, sectionIndex) => {
          const IconComponent = section.icon;
          const isExpanded = expandedSections[sectionIndex];
          
          return (
            <div
              key={sectionIndex}
              className="mb-6"
            >
              <button
                onClick={() => toggleSection(sectionIndex)}
                className={`w-full ${section.bgColor} rounded-2xl p-6 shadow-lg border-l-8 border-gradient-to-b ${section.color} hover:shadow-xl transition-all duration-300 cursor-pointer`}
              >
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${section.color} flex items-center justify-center shadow-lg transform hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <h2 className="text-md md:text-2xl font-black text-gray-900 text-left">
                      {section.title}
                    </h2>
                  </div>
                  <ChevronDown 
                    className={`w-8 h-8 text-gray-600 transition-transform duration-300 flex-shrink-0 ${
                      isExpanded ? 'transform rotate-180' : ''
                    }`}
                  />
                </div>
              </button>

              {/* Rules List - Expandable */}
              <div 
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  isExpanded ? 'max-h-[5000px] opacity-100 mt-4' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
                  {section.rules.map((rule, ruleIndex) => (
                    <div
                      key={ruleIndex}
                      className={`p-6 border-b border-gray-100 last:border-b-0 ${
                        ruleIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                      }`}
                    >
                      <div className="flex gap-4">
                        <div className="flex-shrink-0 mt-1">
                          <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${section.color} flex items-center justify-center shadow-md`}>
                            <span className="text-white font-bold text-sm">{ruleIndex + 1}</span>
                          </div>
                        </div>
                        <div className="flex-1">
                          <p className="text-gray-700 leading-relaxed text-[18px] whitespace-pre-line">
                            {rule}
                          </p>
                        </div>
                        <div className="flex-shrink-0">
                          <CheckCircle className={`w-5 h-5 text-green-500 opacity-50`} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Important Notice */}
      <div className="container mx-auto px-4 pb-16 max-w-5xl">
        <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-2xl p-8 shadow-2xl text-white">
          <div className="md:flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="bg-white/20 backdrop-blur-lg rounded-full p-3 flex items-center gap-3">
                <AlertCircle className="w-8 h-8 text-white " /> <span className='md:hidden block font-bold'>Important Notice</span>
              </div>
            </div>
            <div>
              <h3 className="text-2xl hidden md:block font-bold mb-3">Important Notice</h3>
              <p className="text-white/90 leading-relaxed">
                All members are required to comply with these rules and regulations. Non-compliance may result in the rejection of applications or suspension of membership benefits. For any clarifications, please contact the association office.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Layout>
  );
};

export default Rules;